import { render, staticRenderFns } from "./CommentCollapseCard.vue?vue&type=template&id=6b5c3752"
import script from "./CommentCollapseCard.vue?vue&type=script&lang=js"
export * from "./CommentCollapseCard.vue?vue&type=script&lang=js"
import style0 from "./CommentCollapseCard.vue?vue&type=style&index=0&id=6b5c3752&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports